const config = {
    production: {
        API_BASE_URL: 'https://microservice-dot-dev-splicer-204213.ey.r.appspot.com',
        KI_AGENT_BASE_URL: 'https://aiservice-dot-dev-splicer-204213.ey.r.appspot.com',
        X_API_KEY: 'VdjCKidks7qTEyuU6QeJtezZ3PeCHhZQ2yHJ3kPtcfTN8BjVqU',
        KALKULATION_APP_URL: 'https://kalkulation.muessig.app',
    },
    development: {
        API_BASE_URL: 'http://localhost:8080',
        KI_AGENT_BASE_URL: 'http://localhost:3000',
        X_API_KEY: 'VdjCKidks7qTEyuU6QeJtezZ3PeCHhZQ2yHJ3kPtcfTN8BjVqU',
        KALKULATION_APP_URL: 'http://localhost:5173',
    },
};

export const getConfig = () => {
    // Hier steuerst du ja aktuell manuell die Umgebung
    const env = 'production';
    return config[env];
};

// Produktiv-Hosts des Netzplans. Alles andere gilt als Test/Dev.
const PRODUCTION_HOSTS = [
    'netzplan.muessig.app',
    'networkplan.muessig.app',
    'network-plan-3cd45.web.app',
];

/**
 * Laufzeit-Umgebung anhand des Browser-Hostnamens (unabhängig vom oben manuell gewählten API-`env`).
 * Fallback bei unbekanntem Host: 'production' (konservativ — Test-Features bleiben dann aus).
 */
export const getRuntimeEnv = () => {
    const host = typeof window !== 'undefined' ? window.location.hostname : '';
    if (PRODUCTION_HOSTS.includes(host)) return 'production';
    if (host === 'network-plan-test.web.app') return 'test';
    if (host === 'localhost' || host === '127.0.0.1') return 'development';
    return 'production';
};

/** true nur auf Test-/Dev-Umgebungen — für Features, die (noch) nicht produktiv sichtbar sein sollen. */
export const isTestFeatureEnabled = () => getRuntimeEnv() !== 'production';